module.exports = __webpack_public_path__ + "static/img/postisonLink.c880ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/postisonLink.png
// module id = Ysx+
// module chunks = 1